import { RestaurantCatalogDescription } from "./RestaurantCatalogDescription";

export default RestaurantCatalogDescription;
